import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { useScheduleData, UseScheduleDataReturn } from "../scheduleData";

interface RoomFilterProps {
  selectedRooms: string[];
  onRoomChange: (room: string, checked: boolean) => void;
  onSelectAll: (checked: boolean) => void;
  isDarkMode?: boolean;
}

export function RoomFilter({
  selectedRooms,
  onRoomChange,
  onSelectAll,
  isDarkMode = false,
}: RoomFilterProps) {
  const s = useScheduleData();
  const { rooms = [] } = (s || {}) as Partial<UseScheduleDataReturn>;

  return (
    <div
      className={`rounded-lg border p-4 transition-colors duration-300 ${
        isDarkMode ? "bg-gray-700 border-gray-600" : "bg-white border-gray-200"
      }`}
    >
      <h4
        className={`text-sm font-semibold mb-3 transition-colors duration-300 ${
          isDarkMode ? "text-white" : "text-gray-900"
        }`}
      >
        Room
      </h4>
      <div className="space-y-3">
        <div className="flex items-center space-x-2">
          <Checkbox
            id="select-all-rooms"
            checked={selectedRooms.length === rooms.length && rooms.length > 0}
            onCheckedChange={onSelectAll}
          />
          <label
            htmlFor="select-all-rooms"
            className={`text-sm cursor-pointer transition-colors duration-300 ${
              isDarkMode ? "text-gray-400" : "text-gray-500"
            }`}
          >
            Select All
          </label>
        </div>
        <hr
          className={`transition-colors duration-300 ${
            isDarkMode ? "border-gray-600" : "border-gray-200"
          }`}
        />
        {rooms.map((room) => {
          
          return (
            <div key={room.id} className="flex items-center space-x-3">
              <Checkbox
                id={`room-${room.id}`}
                checked={selectedRooms.includes(room.name)}
                onCheckedChange={(checked) =>
                  onRoomChange(room.name, !!checked)
                }
              />
              <div className="flex flex-col">
                <label
                  htmlFor={`room-${room.id}`}
                  className={`text-sm font-medium cursor-pointer transition-colors duration-300 ${
                    isDarkMode ? "text-gray-200" : "text-gray-800"
                  }`}
                >
                  {room.name}
                </label>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
